var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "preview-modal",
      attrs: { name: "preview-modal", width: "500", height: "auto" }
    },
    [
      _c(
        "button",
        {
          staticClass: "close",
          on: {
            click: function($event) {
              return _vm.$modal.hide("preview-modal")
            }
          }
        },
        [_vm._v("❌")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "m-header" }, [
        _c("div", { staticClass: "h4" }, [_vm._v("Auto-generated Preview")]),
        _vm._v(
          "\n            Allow customers to preview your video before purchase\n        "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "m-body" }, [
        _c("div", { staticClass: "row m-b-20" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("label", { staticClass: "text-secondary" }, [
              _vm._v(
                "\n                        Start Time(s)\n                        "
              ),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.generated_start_time,
                    expression: "generated_start_time"
                  }
                ],
                staticClass: "form-control",
                attrs: { min: "0", placeholder: "00:00:01", type: "number" },
                domProps: { value: _vm.generated_start_time },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.generated_start_time = $event.target.value
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("label", { staticClass: "text-secondary" }, [
              _vm._v(
                "\n                        Length(s)\n                        "
              ),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.generated_duration,
                    expression: "generated_duration"
                  }
                ],
                staticClass: "form-control",
                attrs: { min: "0", placeholder: "00:03:00", type: "number" },
                domProps: { value: _vm.generated_duration },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.generated_duration = $event.target.value
                  }
                }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row m-b-10" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c(
              "button",
              {
                staticClass: "big-btn inverse",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.$modal.hide("preview-modal")
                  }
                }
              },
              [_vm._v("CANCEL")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c(
              "button",
              {
                staticClass: "big-btn",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.generatePreview()
                  }
                }
              },
              [_vm._v("CONTINUE")]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }